export const scratchC = {
  useScratchCardC,
};

function useScratchCardC(context) {
  const scratchConfig = {
    revealThreshold: 80,
    initialDelay: 1000,
    canvasRemovalDelay: 500,
    blurThreshold: 75,
    maxBlur: 10,
  };

  function initScratchCard() {
    const canvas = document.getElementById("scratchCanvas");
    const scratchCode = document.getElementById("scratchCode");
    const scratchContainer = document.querySelector(".scratch-container");
    const loadingElement = document.getElementById("scratchLoading");

    if (!canvas || !scratchCode || !scratchContainer) {
      console.error("Required elements not found for scratch card");
      return;
    }

    let isDrawing = false;
    let lastX = 0;
    let lastY = 0;
    let scratchedPixels = 0;
    let totalPixels = 0;
    let ctx = null;
    let codeRevealed = false;

    setupCanvas();

    function setupCanvas() {
      setTimeout(() => {
        canvas.width = scratchContainer.offsetWidth || 400;
        canvas.height = scratchContainer.offsetHeight || 90;

        ctx = canvas.getContext("2d");

        // Create scratch surface
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, "#c0c0c0");
        gradient.addColorStop(0.5, "#d8d8d8");
        gradient.addColorStop(1, "#c0c0c0");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Texture
        for (let i = 0; i < canvas.width; i += 4) {
          for (let j = 0; j < canvas.height; j += 4) {
            if (Math.random() > 0.5) {
              ctx.fillStyle = "#b5b5b5";
              ctx.fillRect(i, j, 2, 2);
            }
          }
        }

        // Sparkle
        for (let i = 0; i < 50; i++) {
          const x = Math.random() * canvas.width;
          const y = Math.random() * canvas.height;
          const size = Math.random() * 3 + 1;
          ctx.fillStyle = "#e0e0e0";
          ctx.beginPath();
          ctx.arc(x, y, size, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.fillStyle = "#000";
        ctx.font = "bold 20pt Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(">> Gosok di sini <<", canvas.width / 2, canvas.height / 2);

        totalPixels = canvas.width * canvas.height;
        addEventListeners();

        if (loadingElement) loadingElement.style.display = "none";
      }, 800);
    }

    function addEventListeners() {
      canvas.addEventListener("mousedown", startDrawing);
      canvas.addEventListener("mousemove", draw);
      canvas.addEventListener("mouseup", stopDrawing);
      canvas.addEventListener("mouseout", stopDrawing);

      canvas.addEventListener("touchstart", handleTouchStart);
      canvas.addEventListener("touchmove", handleTouchMove);
      canvas.addEventListener("touchend", stopDrawing);
    }

    function handleTouchStart(e) {
      e.preventDefault();
      const touch = e.touches[0];
      const mouseEvent = new MouseEvent("mousedown", {
        clientX: touch.clientX,
        clientY: touch.clientY,
      });
      canvas.dispatchEvent(mouseEvent);
    }

    function handleTouchMove(e) {
      e.preventDefault();
      const touch = e.touches[0];
      const mouseEvent = new MouseEvent("mousemove", {
        clientX: touch.clientX,
        clientY: touch.clientY,
      });
      canvas.dispatchEvent(mouseEvent);
    }

    function startDrawing(e) {
      isDrawing = true;
      [lastX, lastY] = getCoordinates(e);
    }

    function draw(e) {
      if (!isDrawing || !ctx) return;
      const [currentX, currentY] = getCoordinates(e);
      if (isNaN(currentX) || isNaN(currentY)) return;

      ctx.globalCompositeOperation = "destination-out";
      ctx.lineWidth = 30;
      ctx.lineCap = "round";

      ctx.beginPath();
      ctx.moveTo(lastX, lastY);
      ctx.lineTo(currentX, currentY);
      ctx.stroke();

      [lastX, lastY] = [currentX, currentY];
      calculateScratchedPercentage();
    }

    function stopDrawing() {
      isDrawing = false;
    }

    function getCoordinates(e) {
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      return [x, y];
    }

    function calculateScratchedPercentage() {
      if (context.isFirstScratch){
        context.isFirstScratch = false;
        context.sendGtag(0);
      }
      if (!canvas.width || !canvas.height || !ctx) return;
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;

      scratchedPixels = 0;
      for (let i = 3; i < pixels.length; i += 4) {
        if (pixels[i] === 0) scratchedPixels++;
      }

      const percentage = Math.round((scratchedPixels / totalPixels) * 100);

      if (percentage > 5 && scratchCode.style.visibility === "hidden") {
        scratchCode.style.visibility = "visible";
        scratchCode.style.filter = `blur(${scratchConfig.maxBlur}px)`;
      }

      if (percentage > scratchConfig.blurThreshold && percentage < scratchConfig.revealThreshold) {
        const blurRange = scratchConfig.revealThreshold - scratchConfig.blurThreshold;
        const currentProgress = percentage - scratchConfig.blurThreshold;
        const blurAmount = scratchConfig.maxBlur * (1 - currentProgress / blurRange);

        scratchCode.style.filter = `blur(${blurAmount}px)`;
      }

      if (percentage >= scratchConfig.revealThreshold && !codeRevealed){
        revealCode();
        context.isFinishedScratch = true;
      } 
    }

    function revealCode() {
      codeRevealed = true;
      scratchCode.style.color = "#e74c3c";
      scratchCode.style.visibility = "visible";
      scratchCode.style.filter = "blur(0px)";
      setTimeout(() => {
        canvas.style.opacity = "0";
        canvas.style.transition = "opacity 0.3s ease";
        setTimeout(() => {
          canvas.style.display = "none";
        }, 300);
      }, scratchConfig.canvasRemovalDelay);
    }
  }


  initScratchCard();
  if (typeof window.startCountdown === "function") {
    window.startCountdown();
  }
}
